module.exports = __webpack_public_path__ + "static/media/denture.664f4b8e.svg";